import styled from 'styled-components';
import { ColorValue } from 'types/common/CommonType';

interface StyledIconComponentProps {
  $size: number;
  $stroke: ColorValue;
  $fill: ColorValue;
  $strokeWidth: number;
  $rotate: number;
  $hoverBackground: ColorValue;
  $hoverStroke: ColorValue;
  $activeBackground: ColorValue;
  $activeStroke: ColorValue;
  $borderRadius: string;
}

const resolveColor = (color: string) =>
  color.startsWith('#') || color.startsWith('rgb') || color.startsWith('hsl')
    ? color
    : `var(${color})`;

export const StyledIconComponent = styled.div<StyledIconComponentProps>`
  display: flex;
  width: max-content;
  height: max-content;
  background-color: transparent;
  border-radius: ${({ $borderRadius }) => $borderRadius};

  & > svg {
    width: ${(props) => `${props.$size}px`};
    height: ${(props) => `${props.$size}px`};
    transition: transform 0.3s ease;
    transform: ${(props) => (props.$rotate ? `rotate(${props.$rotate}deg)` : '')};
    path {
      stroke: ${(props) => resolveColor(props.$stroke)};
      fill: ${(props) => (props.$fill !== 'NULL' ? resolveColor(props.$fill) : 'none')};
      stroke-width: ${(props) => props.$strokeWidth};
    }
  }

  &:hover {
    background-color: ${({ $hoverBackground }) => resolveColor($hoverBackground)};
    & > svg path {
      stroke: ${({ $hoverStroke }) => resolveColor($hoverStroke)};
    }
  }

  &:active {
    background-color: ${({ $activeBackground }) => resolveColor($activeBackground)};
    & > svg path {
      stroke: ${({ $activeStroke }) => resolveColor($activeStroke)};
    }
  }
`;
